import { createReducer } from '@reduxjs/toolkit'
import { setGamesData, setGamesLoading, setRewardInfo } from './actions'
import { GamesList } from 'services/module/games'

export interface GamesState {
  loading: boolean
  games: GamesList[]
  rewardId: string | number
  rewardType: number
}

const inintSate: GamesState = {
  loading: true,
  games: [],
  rewardId: '',
  rewardType: 0,
}

export default createReducer(inintSate, builder => {
  builder.addCase(setGamesData, (state, { payload }) => {
    state.games = payload
  })
  builder.addCase(setGamesLoading, (state, { payload }) => {
    state.loading = payload
  })
  builder.addCase(setRewardInfo, (state, { payload }) => {
    state.rewardId = payload.rewardId
    state.rewardType = payload.rewardType
  })
})
